import { useState } from 'react';
import useDidUpdate from '~/client/hooks/lifecycle/useDidUpdate';
import useRouter from '~/client/hooks/router/useRouter';
import useAgentData from '~/client/hooks/useAgentData';
import useGameCardSize from '~/client/shared/game/GameCard/useGameCardSize';
import useSelectedFiltersStore from '../../store/useSelectedFiltersStore';

const useGameListHook = ({
  menuItem,
  theme,
  isLiveRtp,
  pageTitle,
  pageSection,
  providerName,
  isRecommendedGames,
  isBombayclubGamesPage,
}: GameListProps) => {
  const [isGridVisible, setGridVisible] = useState(true);
  const { isDesktop } = useAgentData();
  const { width, height } = useGameCardSize(isDesktop);
  const { setCategories, setProviders } = useSelectedFiltersStore();
  const { query } = useRouter();
  const hasFilters =
    menuItem !== 'recent' && menuItem !== 'favourite' && !isRecommendedGames;

  const sectionAsMenuItemList = ['favourite', 'recent'];
  const sectionAsMenuItem =
    pageSection === 'categories' &&
    sectionAsMenuItemList.includes(menuItem ?? '');
  const section = sectionAsMenuItem ? (menuItem as PageSection) : pageSection;

  useDidUpdate(() => {
    setCategories([]);
    setProviders([]);
  }, [query?.handle]);

  const handleGridVisibleToggle = () =>
    setGridVisible((isVisible) => !isVisible);

  const pageSubTitle = isBombayclubGamesPage
    ? 'bombay-club.gamelist-page-subtitle'
    : '';

  return {
    pageTitle: getPageTitleKey(pageTitle ?? ''),
    pageSubTitle,
    pageSection: section,
    hasFilters,
    isLiveRtp,
    height,
    width,
    isGridVisible,
    providerName,
    handleGridVisibleToggle,
    cmsHandle: theme ?? menuItem,
  };
};

const getPageTitleKey = (pageTitle: string) => {
  switch (pageTitle) {
    case 'recent':
      return 'casino.menu_item.recently_played';
    case 'favourite':
      return 'casino.menu_item.favourites';
    default:
      return pageTitle;
  }
};

export default useGameListHook;
